import api from 'utils/api.js';

export const getCreditTransaction = async (params) => {
    const response = await api.get('/merchant/credits/transactions', { params });
    return response.data;
};
